import React, { FC, useState } from "react";

import { Button } from "@mui/material";

import styles from "./SecurityTopic.module.scss";

import ManualSlider from "@/pages/SecurityAwareness/components/ManualSlider";
import { ISecurityTopic } from "@/pages/SecurityAwareness/types";
import TopicForm from "@/pages/SecurityAwareness/components/SecurityTopic/components/TopicForm";

const SecurityTopic: FC<ISecurityTopic> = ({
  slides,
  quizList,
  quizName,
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  const [step, setStep] = useState(0);
  const [isDisplayForm, setIsDisplayForm] = useState(false);
  return (
    <>
      <ManualSlider step={step} setStep={setStep} slides={slides} />
      {!isDisplayForm && (
        <div className={styles.startTestButton}>
          <Button
            onClick={() => setIsDisplayForm(true)}
            variant="text"
            disabled={isPassed}
          >
            Start the test
          </Button>
        </div>
      )}
      {isDisplayForm && (
        <TopicForm
          quizList={quizList}
          quizName={quizName}
          handleNextTopic={handleNextTopic}
          setTestResults={setTestResults}
        />
      )}
    </>
  );
};

export default SecurityTopic;
